const colorPalettes = {
  darkgreen: {
    DEFAULT: "#1C909D",
    50: "#E8F4F5",
    100: "#D2E9EB",
    200: "#B3DADE",
    300: "#8DC7CE",
    400: "#68B5BE",
    500: "#42A2AD",
    700: "#177883",
    800: "#136069",
  },
  orange: {
    DEFAULT: "#E75925",
    50: "#FFEEE7",
    100: "#FADED3",
    200: "#F7C8B6",
    300: "#F3AC92",
    400: "#EF906E",
    500: "#EB7549",
    700: "#C04A1F",
    800: "#9A3B19",
  },
  blue: {
    DEFAULT: "#007CC1",
    50: "#DDF3FF",
    100: "#CCE5F3",
    200: "#AAD3EA",
    300: "#80BDE0",
    400: "#55A8D6",
    500: "#2B92CB",
    700: "#0067A1",
    800: "#005381",
  },
  cus_prevea: {
    DEFAULT: "#373B74",
    50: "#EFF0F9",
    100: "#D7D8E3",
    200: "#B9BACE",
    300: "#9B9DBA",
    400: "#7D80A5",
    500: "#5F6290",
    700: "#2F3263",
    800: "#272951",
  },
} as const;

export interface WhitelabelConfig {
  logo_url?: string;
  logo_mobile_url?: string;
  color_palette?: Whitelabel;
}

export enum Whitelabel {
  default = "default",
  orange = "orange",
  blue = "blue",
  cus_prevea = "cus_prevea",
}

export interface ThemeColorShades {
  50?: string;
  100?: string;
  200?: string;
  300?: string;
  400?: string;
  500?: string;
  700?: string;
  800?: string;
  900?: string;
}

export interface WhitelabelTheme {
  primary: string;
  secondary: string;
  "primary-shades"?: ThemeColorShades;
}

export const whitelabelThemes: Record<Whitelabel, WhitelabelTheme> = {
  default: {
    primary: colorPalettes.darkgreen.DEFAULT,
    secondary: colorPalettes.darkgreen.DEFAULT,
    "primary-shades": colorPalettes.darkgreen,
  },
  orange: {
    primary: colorPalettes.orange.DEFAULT,
    secondary: colorPalettes.orange.DEFAULT,
    "primary-shades": colorPalettes.orange,
  },
  blue: {
    primary: colorPalettes.blue.DEFAULT,
    secondary: colorPalettes.blue.DEFAULT,
    "primary-shades": colorPalettes.blue,
  },
  cus_prevea: {
    primary: colorPalettes.cus_prevea.DEFAULT,
    secondary: "#B2BB1E",
    "primary-shades": colorPalettes.cus_prevea,
  },
};
